import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col-xxl-10 col-lg-8 pe-xxl-8" }
const _hoisted_3 = { class: "transfer-form-panel" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group mb-25 position-relative" }
const _hoisted_7 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-25 position-relative" }
const _hoisted_11 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-25 position-relative" }
const _hoisted_15 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-25" }
const _hoisted_19 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { value: "completed" }
const _hoisted_22 = { value: "pending" }
const _hoisted_23 = { value: "sent" }
const _hoisted_24 = { class: "col-xxl-2 col-lg-4" }
const _hoisted_25 = { class: "card border-0 rounded-1 w-xxl-5 pt-12 pb-12 mb-md-25 shadow-sm transfer-summary-card" }
const _hoisted_26 = { class: "table style-two" }
const _hoisted_27 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_28 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_29 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_30 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_31 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_32 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_33 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_34 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_35 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-semibold"
}
const _hoisted_36 = { class: "fs-14 fw-bold lh-1 text-purple text-end" }
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "form-group mb-25" }
const _hoisted_39 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_40 = ["value", "placeholder"]
const _hoisted_41 = { class: "col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("transfer_page.order_tax")) + " (%)", 1),
              _createElementVNode("input", {
                value: _ctx.form.order_tax,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:formKey', 'order_tax', parseFloat(($event.target as HTMLInputElement).value) || 0))),
                type: "number",
                class: "transfer-form-field w-100 d-block shadow-none fs-14 rounded-1 text-title h-55 ps-3 pe-5",
                placeholder: "0"
              }, null, 40, _hoisted_8),
              _cache[6] || (_cache[6] = _createElementVNode("span", {
                class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center transfer-input-addon",
                style: {"right":"15px","top":"38px"}
              }, " % ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("transfer_page.discount")) + " ($)", 1),
              _createElementVNode("input", {
                value: _ctx.form.discount,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:formKey', 'discount', parseFloat(($event.target as HTMLInputElement).value) || 0))),
                type: "number",
                class: "transfer-form-field w-100 d-block shadow-none fs-14 rounded-1 text-title h-55 ps-3 pe-5",
                placeholder: "0"
              }, null, 40, _hoisted_12),
              _cache[7] || (_cache[7] = _createElementVNode("span", {
                class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16 transfer-input-addon",
                style: {"right":"15px","top":"38px"}
              }, " $ ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("transfer_page.shipping_cost")) + " ($)", 1),
              _createElementVNode("input", {
                value: _ctx.form.shipping,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:formKey', 'shipping', parseFloat(($event.target as HTMLInputElement).value) || 0))),
                type: "number",
                class: "transfer-form-field w-100 d-block shadow-none fs-14 rounded-1 text-title h-55 ps-3 pe-5",
                placeholder: "0"
              }, null, 40, _hoisted_16),
              _cache[8] || (_cache[8] = _createElementVNode("span", {
                class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16 transfer-input-addon",
                style: {"right":"15px","top":"38px"}
              }, "$", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("transfer_page.status")), 1),
              _createElementVNode("select", {
                value: _ctx.form.status,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:formKey', 'status', ($event.target as HTMLSelectElement).value))),
                class: "transfer-form-field rounded-1 fs-14 text-optional w-100 h-55 ps-3"
              }, [
                _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("transfer_page.status_completed")), 1),
                _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t("transfer_page.status_pending")), 1),
                _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("transfer_page.status_sent")), 1)
              ], 40, _hoisted_20)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("table", _hoisted_26, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("transfer_page.order_tax")) + " : ", 1),
              _createElementVNode("td", _hoisted_28, _toDisplayString(Number(_ctx.form.order_tax || 0).toFixed(0)) + " % ", 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t("transfer_page.discount")) + " : ", 1),
              _createElementVNode("td", _hoisted_30, " $ " + _toDisplayString(Number(_ctx.form.discount || 0).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t("transfer_page.shipping")) + " : ", 1),
              _createElementVNode("td", _hoisted_32, " $ " + _toDisplayString(Number(_ctx.form.shipping || 0).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("transfer_page.items")) + " : ", 1),
              _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.totalQty), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("transfer_page.grand_total")) + " : ", 1),
              _createElementVNode("td", _hoisted_36, "$ " + _toDisplayString(Number(_ctx.grandTotal || 0).toFixed(2)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("transfer_page.notes")), 1),
        _createElementVNode("textarea", {
          value: _ctx.form.note,
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:formKey', 'note', ($event.target as HTMLTextAreaElement).value))),
          cols: "30",
          rows: "5",
          placeholder: _ctx.$t('transfer_page.add_note'),
          class: "transfer-form-field d-block w-100 rounded-1 resize-none fs-14 text-title p-3"
        }, null, 40, _hoisted_40)
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("button", {
        class: "btn style-one d-inline-block transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 mb-20",
        type: "button",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit')))
      }, _toDisplayString(_ctx.$t("transfer_page.submit_transfer")), 1)
    ])
  ]))
}